document.addEventListener("load", (e) => {
  console.log(document.body);
});
